import React from 'react';
import Categories from '../components/Categories';
import Products from '../components/Products';
import Newsletter from '../components/Newsletter';
import Slider from '../components/Slider';
import WrapContent from '../components/WrapContent';
import { Box } from '@chakra-ui/react';

const homepage = () => {
  return (
    <Box overflow={'hidden'}>
      <Slider />
      <WrapContent>
        <Categories />
        <Products />
        <Newsletter />
      </WrapContent>
    </Box>
  );
};

export default homepage;
